import { getColumns } from '@/features/profile/tables/sessionsColumns'
import { BaseProfileCard } from '@/features/profile/ui/BaseProfileCard/BaseProfileCard'
import CloseIcon from '@/shared/assets/icons/profile/close.svg?react'
import { BaseButton } from '@/shared/components'
import { BaseTable } from 'syncra-storybook/features'

export const UserSessions = () => {
  const data = null
  const onCLoseSession = () => {}
  const onCLoseAllSession = () => {}
  return (
    <BaseProfileCard title="Сессии">
      {data && (
        <BaseButton
          onClick={onCLoseAllSession}
          icon={<CloseIcon className="text-error" />}
          iconPosition="right"
          variant="setting"
          className="self-start bg-white !px-[30px] !py-[10px]"
        >
          Закрыть все, кроме текущей
        </BaseButton>
      )}

      <BaseTable columns={getColumns(onCLoseSession)} data={data ?? []} cardClasses="border-0" />
    </BaseProfileCard>
  )
}
